import React, { useContext } from "react";
import ActionableCardList, { ActionableCardListItem } from "../../components/ActionableCardList";
import { PageContext } from "../../context/PageContext";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import { getPaneMode } from "../../taskpane";

const items: ActionableCardListItem[] = [
  {
    title: "Chase Receivables",
    icon: AttachEmailIcon,
    link: "/chasables",
    telemetryDashboardEntry: "chase_receivables",
  },
  {
    title: "Process Payables",
    icon: AssuredWorkloadIcon,
    link: "/contacts",
    disabled: getPaneMode() === "compose",
    telemetryDashboardEntry: "process_payables",
  },
  {
    title: "Onboard Customer",
    icon: PersonAddAltIcon,
    handleClick: () => console.log("ok"),
    disabled: true,
  },
  {
    title: "Onboard Supplier",
    icon: AddBusinessIcon,
    handleClick: () => console.log("ok"),
    disabled: true,
  },
  {
    title: "Process Expenses",
    icon: CreditScoreIcon,
    handleClick: () => console.log("ok"),
    disabled: true,
  },
];

const Dashboard = () => {
  const { setNewTitle } = useContext(PageContext);

  React.useEffect(() => {
    setNewTitle("Dashboard");
  }, [setNewTitle]);
  return (
    <>
      <ActionableCardList items={items} />
    </>
  );
};

export default Dashboard;
